export const DATABASE_LIST_WIDTH = 320;

export const SIDE_PANEL_FOOTER_HEIGHT = 68;
export const SIDE_PANEL_TRANSITION_DURATION = 0.5;
export const SIDE_PANEL_TRANSITION_FUNCTION = 'ease';
export const SIDE_PANEL_WIDTH = 320;

export const SIDE_PANEL_MIN_WIDTH = 320;
export const SIDE_PANEL_MAX_WIDTH = 600;

export const MODAL_WIDTH = 400;
export const UPLOAD_MODAL_WIDTH = 600;
export const CREATE_TABLE_MODAL_WIDTH = 600;

export const TOPBAR_NAVIGATION_HEIGHT = 56;
export const TAB_HEIGHT = 49;
export const FILTER_BAR_HEIGHT = 72;

export const TABLE_ROW_HEIGHT = 36;
export const TABLE_CELL_EXPANDED_WIDTH = 465;

export const SIDEBAR_PROFILING_DRAWER_WIDTH = 350;
export const SIDEBAR_PROFILING_CLOSE_BUTTON_SPACE = 64;

export const TOOLTIP_DELAY_IN_MS = 300;

export const RAW_PAGE_SIZE_LIMIT = 100000;

export const RAW_EXPLORER_TAB_PANE_KEY_SEPARATOR =
  'RAW_EXPLORER_TAB_PANE_KEY_SEPARATOR';
